import React from 'react';
import Navigation from './Navigation';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navigation />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </main>
      <footer className="bg-primary-800 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="text-center">
            <p className="text-primary-200">
              © 2024 Ayurvedic Herb Traceability System. Ensuring authenticity through blockchain technology.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
